import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PAuthComponent } from './pauth.component';
import { PLoginAuthGuard } from './plogin-auth-guard.service';
import { SharedModule } from '../shared';
import { ClientResolver } from './client-resolver.service';
import {NgxMaskModule} from 'ngx-mask';
import {AppRoutingModule} from '../app.routing'
import { NoAuthGuard } from '../auth/no-auth-guard.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}

@NgModule({
  imports: [
    AppRoutingModule,
	  NgxMaskModule,
    SharedModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    PAuthComponent
  ],

  providers: [
    NoAuthGuard,
    ClientResolver
  ]
})
export class PAuthModule {}
